import { defineComponent as _defineComponent } from 'vue'
import { useAuthUserStore } from '../stores/authUser'
import PATList from '../components/PATList.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PATsView',
  setup(__props) {


const authUserStore = useAuthUserStore()

const email = authUserStore.user?.email || "Unknown"


return { __sfc: true,authUserStore, email, PATList }
}

})